import PropTypes from 'prop-types';

export default {
	fromAccount: PropTypes.shape({
		id: PropTypes.string,
		balances: PropTypes.arrayOf(
			PropTypes.shape({
				type: PropTypes.string,
				amount: PropTypes.number,
				currency: PropTypes.string,
			})
		),
	}),
	toAccount: PropTypes.shape({
		id: PropTypes.string,
		to_account: PropTypes.shape({
			sort_code: PropTypes.string,
			account_number: PropTypes.string,
			name: PropTypes.string,
		}),
	}),
	payee: PropTypes.shape({
		id: PropTypes.string,
		to_account: PropTypes.shape({
			sort_code: PropTypes.string,
			account_number: PropTypes.string,
			name: PropTypes.string,
		}),
	}),
};
